import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { updateLayoutConfiguration } from 'actions/layoutConfiguration';
import Icon from 'components/ui/icon';
import { Badge } from 'components/ui/badge';
import LocalStorage from 'helpers/LocalStorage';
import './helpdeskToggle.scss';

const HelpDeskToggle: FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const isHelpdeskExpanded = useSelector(
    (state: RootState) =>
      state.layoutConfiguration?.isHelpdeskExpanded ??
      LocalStorage.get('helpdesk_closed') === false
  );

  const { tips, supportMessages } = user || {};
  const unreadMessages = Number(supportMessages?.unreadCount) || 0;
  const unreadTip =
    tips && tips.currentTip
      ? Number(tips.list?.[tips.currentTip] === false)
      : 0;
  const badgeCount = unreadMessages + unreadTip;

  const handleToogle = () => {
    dispatch(
      updateLayoutConfiguration({ isHelpdeskExpanded: !isHelpdeskExpanded })
    );
    LocalStorage.set('helpdesk_closed', isHelpdeskExpanded);
  };

  return (
    <div onClick={handleToogle} className='helpdesk-toggle'>
      <Icon size={16} className='helpdesk-toggle__icon' name='im-Helpdesk' />

      {badgeCount > 0 ? (
        <Badge
          position={{
            top: 0,
            right: -4,
          }}
          count={badgeCount}
        />
      ) : null}
    </div>
  );
};

export default HelpDeskToggle;
